import { Controller } from "@hotwired/stimulus"

// Slides a routine product's row away as its delete is submitted. The
// response redraws the row's section (closing the gap, renumbering steps,
// updating a group it left) and shows the Undo toast.
export default class extends Controller {
  static targets = ["container", "deleteForm"]

  connect() {
    if (this.hasDeleteFormTarget) {
      this.deleteFormTarget.addEventListener("turbo:submit-start", this.handleDelete)
    }
    document.addEventListener("turbo:before-stream-render", this.holdSectionRender)
  }

  disconnect() {
    if (this.hasDeleteFormTarget) {
      this.deleteFormTarget.removeEventListener("turbo:submit-start", this.handleDelete)
    }
    document.removeEventListener("turbo:before-stream-render", this.holdSectionRender)
  }

  // Edit mode's delete badge submits the row's swipe-action form.
  // The badge can sit inside the product link, so don't follow it.
  submit(event) {
    event.preventDefault()
    this.deleteFormTarget.requestSubmit()
  }

  handleDelete = () => {
    const container = this.containerTarget

    container.style.transition = "all 0.3s ease-out"
    container.style.overflow = "hidden"
    container.style.opacity = "0"
    container.style.transform = "translateX(-100%)"

    this.removed = new Promise((resolve) => {
      setTimeout(() => {
        container.style.height = `${container.scrollHeight}px`
        container.offsetHeight // Force reflow so the collapse animates from the current height.
        container.style.height = "0"
        container.style.marginBottom = "0"
        container.style.paddingTop = "0"
        container.style.paddingBottom = "0"

        setTimeout(() => {
          resolve()
          container.remove()
        }, 300)
      }, 300)
    })
  }

  // The redrawn section would cut the slide short, so it waits for the row
  // to finish leaving. A response that arrives later renders straight away,
  // since this controller has left with its row by then.
  holdSectionRender = (event) => {
    if (!this.removed) return
    if (!event.target.getAttribute("target")?.endsWith("_routine_section")) return

    const render = event.detail.render
    event.detail.render = async (streamElement) => {
      await this.removed
      await render(streamElement)
    }
  }
}
